import React, { useState, useEffect, useContext, useCallback, } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import DataTable from "react-data-table-component";
import { getMeterData } from "services/ConfigServices";
import { methodData, displayData, displayDataonehour, monthnameData, datachoiceData, divisionUnitData } from "variables/lists/meters";
import { metersdatapagetext } from "variables/meters";
import { dico } from "variables/lists/dico";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import zipcelx from 'zipcelx';
import MenuIcon from "@mui/icons-material/Menu";
import { Menu, MenuItem } from "@mui/material";
import 'moment/locale/fr';
import { CSVLink } from "react-csv";
import {
  DateInput,
} from "components/Input/Index.js";
import debounce from "lodash/debounce";

const downloadCsvButton = {
  textDecoration: 'none',
  color: 'rgb(0 0 0 / 87%)'
}
const menuItemStyle = {
  fontSize: '1.2rem',
  fontFamily: '"Source Sans Pro",sans-serif',
}
const menuButtonStyle = {
  float: "right",
  position: "relative",
  marginRight: "-0.5rem",
  paddingTop: "9px",
  fontFamily: '"Source Sans Pro",sans-serif',
};
const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;
const Data = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
`;
const DataMargin = styled.div`
font-size: 14px;
font-weight: 500;
opacity: 1;
margin-left: 15px;
`;
const DataResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  margin-left: auto;
  text-align: right;
`;
const DataResultLink = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  margin-left: auto;
  text-align: right;
  cursor: pointer;
  text-decoration: underline;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const HighchartsContainer = styled.div`
  margin-top: 1.5rem;
  margin-right: 1rem;
`;

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;



function ViewMeterDataDialog(props) {
  const { closeModal, meter, energy } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { groupInfoListById, setPage } = advancedSearchContext;
  const [type, setType] = useState("");
  const [method, setMethod] = useState("");
  const [datebegin, setDatebegin] = useState(moment().subtract(1, 'month').format("YYYY-MM-DD"));
  const [dateend, setDateend] = useState(moment().format("YYYY-MM-DD"));
  const [display, setDisplay] = useState("tab");
  const [data, setData] = useState([]);
  const [highchartData, setHighchartData] = useState([]);
  const [highchartDataHeatMap, setHighchartDataHeatMap] = useState([]);
  const [datesdata, setDatesdata] = useState([]);
  const [daterange, setDaterange] = useState("0");
  const [sitesData, setSitesData] = useState([]);
  const [site, setSite] = useState(0);
  const [filtereddatachoicedata, setFiltereddatachoicedata] = useState([]);
  const [methodindex, setMethodindex] = useState("rawload");
  const chartRef = React.useRef(null);
  const [openMenu, setOpenMenu] = React.useState(null);
  const [csvHeaders, setCsvHeaders] = useState([]);
  const [csvLines, setCsvLines] = useState([]);
  const [loading, setLoading] = useState(false);
  const classes = useStyles();


  const handleSiteChange = (event) => {
    if (site != 0 && event.target.value == 0) {
      if (type.startsWith('load_'))
        setMethodindex('rawload');
      else if (type.startsWith('bill_'))
        setMethodindex('rawbill');
      setMethod('');
    }
    else if (site == 0 && event.target.value != 0) {
      if (type.startsWith('load_'))
        setMethodindex('siteload');
      else if (type.startsWith('bill_'))
        setMethodindex('sitebill');
      setMethod('');
    }
    setSite(event.target.value);
  };
  const handleTypeChange = (event) => {
    if (!type.startsWith('load_') && event.target.value.startsWith('load_')) {
      if (site != 0)
        setMethodindex('siteload');
      else if (site == 0)
        setMethodindex('rawload');
      setMethod('');
    }
    if (!type.startsWith('bill_') && event.target.value.startsWith('bill_')) {
      if (site != 0)
        setMethodindex('sitebill');
      else if (site == 0)
        setMethodindex('rawbill');
      setMethod('');
    }
    setType(event.target.value);
  };
  const handleMethodChange = (event) => {
    setDisplay('tab');
    if (method === '10m') {
      setDatebegin(datesdata.find((obj) => obj.id === "0").datebegin);
      setDateend(datesdata.find((obj) => obj.id === "0").dateend);
      setDaterange("0");
    }
    setMethod(event.target.value);
  };
  const handleDisplayChange = (event) => { setDisplay(event.target.value); };
  const handleDaterangeChange = (event) => {
    setDaterange(event.target.value);
    if (event.target.value === "-1")
      return;
    setDatebegin(datesdata.find((obj) => obj.id === event.target.value).datebegin);
    setDateend(datesdata.find((obj) => obj.id === event.target.value).dateend);
  };
  const handleDatebeginChange = (event) => {
    let newdatebegin = event.target.value;
    if (moment(newdatebegin).isAfter(moment(dateend)))
      setDateend(newdatebegin);
    setDatebegin(newdatebegin);
  };
  const handleDateendChange = (event) => {
    let newdateend = event.target.value;
    if (moment(newdateend).isBefore(moment(datebegin)))
      setDatebegin(newdateend);
    setDateend(newdateend);
  };

  useEffect(() => {
    if (meter) {
      let sites = meter.distribution?.map((dis) => {
        let site = {};
        site.id = dis.groupid;
        site.name = (groupInfoListById["" + dis.groupid] || "" + dis.groupid) + " " + dis.divisionvalue + "" + divisionUnitData.find((obj) => obj.id === dis.divisionunit).name;
        return site;
      });
      if (!sites)
        sites = [];
      sites.unshift({ id: 0, name: 'Données brutes du compteur' });
      setSitesData(sites);

      let tmpdatachoicedata = datachoiceData.filter((item) =>
        energy === item.energy
      );
      if (energy === 'electricity') {
        tmpdatachoicedata = tmpdatachoicedata.filter((item) =>
          item.segment.includes(meter.details.segment)
        );
      }
      setFiltereddatachoicedata(tmpdatachoicedata);
    }
  }, [meter]);

  useEffect(() => {
    if ((site || site == 0) && meter.meternumber && energy && datebegin && dateend && type && method) {
      setData([]);
      setHighchartData([]);
      setHighchartDataHeatMap([]);
      setCsvLines([]);
      setCsvHeaders([]);
      setLoading(true);
      debouceRequest(site, datebegin, dateend, type, method);
    }
  }, [method, datebegin, dateend, site, type]);

  const debouceRequest = useCallback((l_site, l_datebegin, l_dateend, l_type, l_method) => getData(l_site, l_datebegin, l_dateend, l_type, l_method), []);

  const getData = debounce((l_site, l_datebegin, l_dateend, l_type, l_method) => {
    setData([]);
    setLoading(true);
    axios
      .get(getMeterData(l_site, meter.meternumber, energy, l_datebegin, l_dateend, l_type, l_method, meter.id), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        if (res.status == 200) {
          let sorteddata = res.data.sort((a, b) => a.date - b.date);
          sorteddata = sorteddata.reduce((accumulator, currentObject) => {
            const found = accumulator.find(a => a.date === currentObject.date);
            const value = Number(currentObject.value); // the element in data property
            if (!found) {
              accumulator.push({ date: currentObject.date, value: value })
            }
            else {
              found.value += value;
            }
            return accumulator;
          }, []);
          setData(sorteddata);
          let csvlinestmp = [];
          let highdata = [];
          if (sorteddata) {
            highdata = sorteddata.map((item) => {
              let dataobj = [];
              dataobj.push(item.date);
              dataobj.push(Number(item.value));

              let csvline = {};
              csvline.date = moment(item.date).utc().format("DD/MM/YYYY HH:mm");
              csvline.value = Number(item.value);
              csvlinestmp.push(csvline);

              return dataobj;
            });
          }
          setCsvLines(csvlinestmp);
          setHighchartData(highdata);
          let highdataheatmap = [];
          if (sorteddata) {
            highdataheatmap = sorteddata.map((item) => {
              let dataobj = [];
              let dateday = moment(item.date).utc().hour(0).minute(0).second(0).unix() * 1000;
              dataobj.push(dateday);
              dataobj.push(Number(moment(item.date).utc().format("HH")));
              dataobj.push(Number(item.value));
              return dataobj;
            });
          }
          setHighchartDataHeatMap(highdataheatmap);

          const headerdate = { label: metersdatapagetext.date, key: 'date' };
          const headerval = { label: metersdatapagetext.value + '(' + datachoiceData.find((x) => x.id == type)?.unit + ')', key: "value" };

          setCsvHeaders([headerdate, headerval]);
        }

        setLoading(false);
      });
  }, 1000);


  useEffect(() => {
    let datesdatatmp = [];
    let nowmoment = moment();
    let onemonthmoment = moment().subtract(1, 'month');
    datesdatatmp.push({ id: "-1", name: "Dates personnalisées" });
    datesdatatmp.push({ id: "0", name: "1 mois glissant", datebegin: onemonthmoment.format("YYYY-MM-DD"), dateend: nowmoment.format("YYYY-MM-DD") });
    let oneyearmoment = moment().subtract(12, 'month');
    datesdatatmp.push({ id: "1000", name: "12 mois glissant", datebegin: oneyearmoment.format("YYYY-MM-DD"), dateend: nowmoment.format("YYYY-MM-DD") });
    for (let i = 1; i <= 24; i++) {
      let substractedmoment = moment().subtract(i, 'month');
      let month = monthnameData.find((obj) => obj.id === substractedmoment.format("MMMM")).name;
      let year = substractedmoment.format("YYYY");
      let datebeginstr = substractedmoment.set('date', 1).format("YYYY-MM-DD");
      let dateendstr = substractedmoment.add(1, 'month').set('date', 1).subtract(1, 'day').format("YYYY-MM-DD"); //go to the end of month
      datesdatatmp.push({ id: "" + i, name: month + " " + year, datebegin: datebeginstr, dateend: dateendstr });
    }
    setDatesdata(datesdatatmp);
  }, []);


  const columns = [
    {
      name: metersdatapagetext.date,
      selector: (row) => row.date,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.date && moment(row.date).isValid()
          ? moment(row.date).utc().format("DD/MM/YYYY HH:mm")
          : "",
    },
    {
      name: metersdatapagetext.value + '(' + datachoiceData.find((x) => x.id == type)?.unit + ')',
      selector: (row) => row.value,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.value ? new Intl.NumberFormat('fr-FR').format(row.value) : ""
    },
  ]


  Highcharts.dateFormats.W = function (timestamp) {
    let date = new Date(timestamp),
      day = date.getUTCDay() === 0 ? 7 : date.getUTCDay(),
      dayNumber;

    date.setDate(date.getUTCDate() + 4 - day);
    dayNumber = Math.floor(
      (date.getTime() - new Date(date.getUTCFullYear(), 0, 1, -6)) / 86400000
    );

    return 1 + Math.floor(dayNumber / 7);
  };
  Highcharts.dateFormats.A = function (val) {
    if (val === 1) return "Dimanche";
    else if (val === 2) return "Lundi";
    else if (val === 3) return "Mardi";
    else if (val === 4) return "Mercredi";
    else if (val === 5) return "Jeudi";
    else if (val === 6) return "Vendredi";
    else if (val === 7) return "Samedi";
  };
  Highcharts.dateFormats.B = function (val) {
    if (val === 0) return "Janvier";
    else if (val === 1) return "Février";
    else if (val === 2) return "Mars";
    else if (val === 3) return "Avril";
    else if (val === 4) return "Mai";
    else if (val === 5) return "Juin";
    else if (val === 6) return "Juillet";
    else if (val === 7) return "Août";
    else if (val === 8) return "Septembre";
    else if (val === 9) return "Octobre";
    else if (val === 10) return "Novembre";
    else if (val === 11) return "Décembre";
  };

  Highcharts.setOptions({
    lang: {
      months: [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
      ],
      weekdays: [
        "Dimanche",
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi",
      ],
      shortMonths: [
        "Jan",
        "Fév",
        "Mar",
        "Avr",
        "Mai",
        "Juin",
        "Juil",
        "Août",
        "Sep",
        "Oct",
        "Nov",
        "Déc",
      ],
      loading: "L'opération progresse...",
      resetZoom: "Réinitialiser le zoom",
      thousandsSep: " ",
      decimalPoint: ",",
      noData: "Aucune donnée à afficher",
    },
  });

  const optionHeatMapChart = {
    chart: {
      type: "heatmap",
      useUTC: false,
    },

    boost: {
      useGPUTranslations: true,
    },

    title: {
      text: "",
      //align: 'left',
      //x: 40
    },

    legend: {
      itemStyle: {
        color: "#000000",
        fontWeight: "600",
        fontFamily: '"Source Sans Pro",sans-serif',
      },
    },
    subtitle: {
      text: "",
      //align: 'left',
      //x: 40
    },

    xAxis: {
      type: "datetime",
      labels: {
        format: "{value:%e %b, %Y}", //TODO xAxisLabelFormat
      },
    },

    yAxis: {
      title: {
        text: null,
      },
      labels: {
        format: "{value}:00", //TODO yAxisLabelFormat
      },
      minPadding: 0,
      maxPadding: 0,
      startOnTick: false,
      endOnTick: false,
      //tickPositions: [0, 6, 12, 18, 24],
      tickWidth: 1,

      reversed: true,
    },

    colorAxis: {
      stops: [
        [0, '#3060cf'],
        [0.5, '#fffbbc'],
        [0.9, '#c4463a'],
        [1, '#c4463a'],
      ], //TODO colorAxis.stops
      startOnTick: false,
      endOnTick: false,
      labels: {
        format: "{value}",
      },
    },
    exporting: {
      enabled: false,
    },
    credits: { enabled: false },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              floating: false,
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
              x: 0,
              y: 0,
            },
            yAxis: [
              {
                labels: {
                  align: "right",
                  x: 0,
                  y: -6,
                },
                showLastLabel: false,
              },
              {
                labels: {
                  align: "left",
                  x: 0,
                  y: -6,
                },
                showLastLabel: false,
              },
              {
                visible: false,
              },
            ],
          },
        },
      ],
    },
    series: [
      {
        dataLabels: {
          enabled: false,
          color: "#000000",
        },
        boostThreshold: 100,
        borderWidth: 0,
        nullColor: "#EFEFEF",
        colsize: 86400000, // TODO series > colsize
        tooltip: {
          headerFormat: datachoiceData.find((x) => x.id == type)?.name + ' (' + datachoiceData.find((x) => x.id == type)?.unit + ')', //TODO series > name
          pointFormat: "{point.x:%e %b, %Y} {point.y}:00: <b>{point.value} <\/b>", //TODO series > pointFormat
        },
        turboThreshold: Number.MAX_VALUE, // #3404, remove after 4.0.5 release
        data: highchartDataHeatMap || [],
      },
    ]
  };

  const optionsColumnChart = {
    chart: {
      zoomType: "x",
      type: "column",
      height: "350px",
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "",
    },
    xAxis: {
      type: "datetime",
    },
    yAxis: [
      {
        title: {
          text: datachoiceData.find((x) => x.id == type)?.unit || "",
        },
      },
    ],
    legend: {
      shadow: false,
      //enabled: false
    },
    tooltip: {
      shared: true,
      formatter: function (chart) {
        moment.locale('fr');
        let points = this.points;
        let s = "";
        if (points) {
          let pointsLength = points.length;
          let index;
          s =
            "<b>" +
            moment(this.x).utc().format("DD/MM/YYYY HH:mm") +
            "</b><br/>";
          for (index = 0; index < pointsLength; index += 1) {
            s +=
              '<span style="color:' +
              points[index].series.color +
              ';">\u25CF</span> ' +
              points[index].series.name.slice(0, 40) +
              " : " +
              Math.round(points[index].y * 100) / 100 +
              " " +
              datachoiceData.find((x) => x.id == type)?.unit +
              "</b><br/>";
          }
        }
        return s;
      },
    },
    plotOptions: {
      column: {
        grouping: false,
        shadow: false,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: datachoiceData.find((x) => x.id == type)?.name || "",
        // color: colorRef,
        data: highchartData || [],
        tooltip: {
          valueSuffix: datachoiceData.find((x) => x.id == type)?.unit || "",
        },
      },
    ],
  };

  const optionsLineChart = {
    chart: {
      zoomType: "x",
      type: "line",
      height: "350px",
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "",
    },
    xAxis: {
      type: "datetime",
    },
    yAxis: [
      {
        title: {
          text: datachoiceData.find((x) => x.id == type)?.unit || "",
        },
      },
    ],
    legend: {
      shadow: false,
      //enabled: false
    },
    tooltip: {
      shared: true,
      formatter: function (chart) {
        moment.locale('fr');
        let points = this.points;
        let s = "";
        if (points) {
          let pointsLength = points.length;
          let index;
          s =
            "<b>" +
            moment(this.x).utc().format("DD/MM/YYYY HH:mm") +
            "</b><br/>";
          for (index = 0; index < pointsLength; index += 1) {
            s +=
              '<span style="color:' +
              points[index].series.color +
              ';">\u25CF</span> ' +
              points[index].series.name.slice(0, 40) +
              " : " +
              Math.round(points[index].y * 100) / 100 +
              " " +
              datachoiceData.find((x) => x.id == type)?.unit +
              "</b><br/>";
          }
        }
        return s;
      },
    },
    plotOptions: {
      column: {
        grouping: false,
        shadow: false,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: datachoiceData.find((x) => x.id == type)?.name || "",
        // color: colorRef,
        data: highchartData || [],
        tooltip: {
          valueSuffix: datachoiceData.find((x) => x.id == type)?.unit || "",
        },
      },
    ],
  };

  const handleClick = (event) => {
    setOpenMenu(event.currentTarget);
  };

  const handleClose = () => {
    setOpenMenu(null);
  };

  const downloadPng = () => {
    const chartToExport = display === 'barchart' ? optionsColumnChart : display === 'linechart' ? optionsLineChart : optionHeatMapChart;
    chartToExport.title.text = "";
    chartRef.current.chart.exportChart({
      type: "image/png",
      filename: "export",
    }, chartToExport);
    chartToExport.title.text = "";
    handleClose();
  };

  const downloadCsv = () => {
    chartRef.current.chart.downloadCSV();
    handleClose();
  };

  const downloadXlsx = () => {
    var div = document.createElement('div'),
      name,
      xlsxRows = [],
      rows;
    div.style.display = 'none';
    document.body.appendChild(div);
    rows = chartRef.current.chart.getDataRows(true);
    var datetime = false;
    if (rows.length > 0) {
      if (rows[0][0] === 'DateTime') {
        datetime = true;
      }
    }
    xlsxRows = rows.slice(1).map((row, rowindex) => {
      return row.map((column, index) => {
        if (rowindex > 0 && index === 0 && datetime) {
          column = moment(column).format("DD/MM/YYYY HH:mm");
        }
        return {
          type: typeof column === 'number' ? 'number' : 'string',
          value: column
        };
      });
    });
    zipcelx({
      filename: "export",
      sheet: {
        data: xlsxRows
      }
    });
    handleClose();
  };
  const downloadXlsxTab = () => {
    var div = document.createElement('div'),
      name,
      xlsxRows = [],
      rows;

    const headerdate = { value: metersdatapagetext.date, type: 'string' };
    const headerval = { value: metersdatapagetext.value + '(' + datachoiceData.find((x) => x.id == type)?.unit + ')', type: "string" };
    var headers = [headerdate, headerval]


    xlsxRows = data.map((row, rowindex) => {
      let xlsxrow = [{ type: 'string', value: moment(row.date).utc().format("DD/MM/YYYY HH:mm") }, { type: 'string', value: row.value ? new Intl.NumberFormat('fr-FR').format(row.value) : "" }];
      return xlsxrow
    });

    xlsxRows.unshift(headers);

    zipcelx({
      filename: "export",
      sheet: {
        data: xlsxRows
      }
    });
    handleClose();
  };

  return (
    <>
      <form className={classes.root}>
        {meter &&
          <GridContainer>
            <GridItem xs={12} sm={12} md={4} lg={4}>
              <div>
                <CustomSelect
                  inputTitle={metersdatapagetext.site}
                  selectValue={site}
                  handleSelectValueChange={handleSiteChange}
                  data={sitesData}
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={4} lg={4}>
              <div>
                <CustomSelect
                  inputTitle={metersdatapagetext.type}
                  selectValue={type}
                  handleSelectValueChange={handleTypeChange}
                  data={filtereddatachoicedata}
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={4} lg={4}>
              <div>
                <CustomSelect
                  inputTitle={metersdatapagetext.method}
                  selectValue={method}
                  handleSelectValueChange={handleMethodChange}
                  data={methodData[methodindex]}
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={3} lg={3}>
              <div>
                <CustomSelect
                  inputTitle={metersdatapagetext.daterange}
                  selectValue={daterange}
                  handleSelectValueChange={handleDaterangeChange}
                  data={datesdata}
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={3} lg={3}>
              <div>
                <DateInput
                  inputTitle={metersdatapagetext.datebegin}
                  dateInput={datebegin}
                  handleDateInputChange={handleDatebeginChange}
                  disabled={daterange !== "-1"}
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={3} lg={3}>
              <div>
                <DateInput
                  inputTitle={metersdatapagetext.dateend}
                  dateInput={dateend}
                  handleDateInputChange={handleDateendChange}
                  disabled={daterange !== "-1"}
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={3} lg={3}>
              <div>
                <CustomSelect
                  inputTitle={metersdatapagetext.display}
                  selectValue={display}
                  handleSelectValueChange={handleDisplayChange}
                  data={method === '1h' ? displayDataonehour : displayData}
                />
              </div>
            </GridItem>
            {
              loading ?
                <GridItem xs={12} sm={12} md={12} lg={12}><div style={{ paddingTop: "12px", marginLeft: "35%" }}>Récupération des données en cours...</div></GridItem>
                :
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  {display === 'tab' ?
                    <Container>
                      <div>
                        <Button
                          aria-controls="chart-menu"
                          aria-haspopup="true"
                          onClick={handleClick}
                          justicon={"true"}
                          style={menuButtonStyle}
                        >
                          <MenuIcon />
                        </Button>
                        <Menu
                          id="simple-menu"
                          className={"menu-chart"}
                          anchorEl={openMenu}
                          keepMounted
                          open={Boolean(openMenu)}
                          onClose={handleClose}
                          style={menuItemStyle}
                        >
                          <MenuItem onClick={downloadXlsxTab} key={`downCsv${Math.random()}`}>
                            Télécharger en XLSX
                          </MenuItem>
                          <MenuItem key={Math.random()}>
                            <CSVLink
                              className={'csv'} data={csvLines}
                              headers={csvHeaders} style={downloadCsvButton}
                              filename={`export.csv`} target="_blank"
                              separator={";"}
                            >
                              Télécharger en CSV
                            </CSVLink>
                          </MenuItem>
                        </Menu>
                      </div>
                      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
                        dense
                        noDataComponent={<NoData>{metersdatapagetext.nodata}</NoData>}
                        noHeader={true}
                        columns={columns}
                        persistTableHead
                        pagination
                        data={data}
                        paginationComponentOptions={{
                          noRowsPerPage: false,
                          rowsPerPageText: "Lignes par page",
                          rangeSeparatorText: "sur",
                          selectAllRowsItem: false,
                          selectAllRowsItemText: "Selectionner toutes les lignes",
                        }}
                      />
                    </Container>
                    :
                    <>
                      <div>
                        <Button
                          aria-controls="chart-menu"
                          aria-haspopup="true"
                          onClick={handleClick}
                          justicon={"true"}
                          style={menuButtonStyle}
                        >
                          <MenuIcon />
                        </Button>
                        <Menu
                          id="chart-menu"
                          className={"chart-menu"}
                          anchorEl={openMenu}
                          keepMounted
                          aria-haspopup={'menu'}
                          open={Boolean(openMenu)}
                          onClose={handleClose}
                        >
                          <MenuItem onClick={downloadPng} key={`downPng_${Math.random()}`}>
                            Télécharger en PNG
                          </MenuItem>
                          <MenuItem onClick={downloadXlsx} key={`downCsv${Math.random()}`}>
                            Télécharger en XLSX
                          </MenuItem>
                          <MenuItem onClick={downloadCsv} key={`downCsv${Math.random()}`}>
                            Télécharger en CSV
                          </MenuItem>
                        </Menu>
                      </div>
                      {display === 'barchart' &&
                        <HighchartsContainer>
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={optionsColumnChart}
                            ref={chartRef}
                          />
                        </HighchartsContainer>
                      }
                      {display === 'linechart' &&
                        <HighchartsContainer>
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={optionsLineChart}
                            ref={chartRef}
                          />
                        </HighchartsContainer>
                      }
                      {display === 'heatmap' &&
                        <HighchartsContainer>
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={optionHeatMapChart}
                            ref={chartRef}
                          />
                        </HighchartsContainer>
                      }
                    </>
                  }
                </GridItem>
            }

          </GridContainer>}
      </form>
    </>
  );
}

export default ViewMeterDataDialog;
